export const metricFilterTypes: Set<string> = new Set([
  "network_in",
  "network_out",
]);
